import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { EditSquare } from '../../../components/Icon';
import { VBox, HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { FormField } from '../../../components/FormFields';
import { Checkbox } from '../../../components/Checkbox';
import Dropdown from '../../../components/Dropdown/ReactDropdown';
import { Input } from '../../../components/Input';
import { updateCompanyProperties } from '../actions';
import {
  COMPANY_DETAILS_COMPANY_DATA_CARD,
  COMPANY_DETAILS_COMPANY_OWNER_CARD,
  COMPANY_VINDAT_RELATION_OPTIONS,
  COMPANY_VINDAT_FRANCHISEFOMULE_OPTIONS,
  COMPANY_VINDAT_LEGAL_OPTIONS,
} from '../constants';
import { getPropByName } from '../../../utils/props';
import { COLOR_PRIMARY_1 } from '../../../vars';
import { isWithInstallation } from '../../Vehicles/helpers';
import { REQUEST_USER_INPUT, WIENTJES_INSTALATION } from '../../../containers/App/constants';
import { selectConfig } from '../../Api/selectors';

const Container = styled.div`
  font-size: 14px;

  .card-header {
    margin-bottom: 20px;
  }
  .card-title {
    white-space: nowrap;
  }

  .cell:first-child {
    text-transform: capitalize;
  }

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }
  .icon-edit-square {
    color: #d9d9d9;
  }

  input {
    width: 100%;
  }

  .row-input {
    .col-1 {
      flex-basis: 25%;
    }
    .col-2 {
      flex-basis: 57%;
    }
  }

  .dropdown-wrapper {
    .dropdown-card {
      height: 35px;
    }
  }

  .link-wrap {
    cursor: pointer;
    &:hover {
      color: ${COLOR_PRIMARY_1};
    }
  }
`;

const DROPDOWN_OPTIONS = {
  company_from_eu: ['NL', 'EU', 'OUTSIDE_EU'],
  ORB_TDN_preference: ['ORB', 'TDN'],
  Vindat_Relation: COMPANY_VINDAT_RELATION_OPTIONS,
  Vindat_Franchisefomule: COMPANY_VINDAT_FRANCHISEFOMULE_OPTIONS,
  vindat_legal_form: COMPANY_VINDAT_LEGAL_OPTIONS,
};

const STATE = {
  isEditCompany: false,
};
/* eslint-disable react/prefer-stateless-function */
class CompanyOwnerCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    COMPANY_DETAILS_COMPANY_OWNER_CARD.map(property => {
      if (this.props.company[property]) {
        this.setState({ [property]: this.props.company[property] });
      }
    });
    if (this.props.company?.country_code) {
      this.setState({ country_code: this.props.company?.country_code });
    }
  }

 

  dropdown(type) {
    const vals = DROPDOWN_OPTIONS[type];

    const options = vals.map(val => ({
      label: this.lbl(`company.property.${type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.state[type]);

    return (
      <div className="dropdown-wrapper">
        <FormField>
          <Dropdown
            controlClassName={'dropdown-card'}
            options={options}
            value={value}
            onChange={pair => this.setState({ [type]: pair.value })}
          />
        </FormField>
      </div>
    );
  }

  input(type) {
    return (
      <FormField>
        <Input
          className="card-input"
          value={this.state[type]}
          onChange={evt => this.setState({ [type]: evt.target.value })}
        />
      </FormField>
    );
  }

  phoneNumber() {
    const fields = ['country_code', 'phone_number'];
    return (
      <HBox className="row-input" left>
        {fields.map((field, idx) => {
          return (
            <div key={field} className={`col-${idx + 1}`}>
              <FormField>
                <Input
                  type="number"
                  value={this.state[field] || ''}
                  onChange={evt => this.setState({ [field]: evt.target.value })}
                />
              </FormField>
            </div>
          );
        })}
      </HBox>
    );
  }

  checkbox(type) {
    return (
      <FormField>
        <Checkbox
          onChange={() => {
            if (!this.state.isEditCompany) return;
            const value = this.state[type] === '1' ? '0' : '1';

            this.setState({ [type]: value });
          }}
          checked={this.state[type] == '1'}
        ></Checkbox>
      </FormField>
    );
  }

  isShowPropertyCell(type) {
    if (this.state.isEditCompany) {
      return true;
    }
    if (this.props.company[type] && !this.state.isEditCompany) {
      return true;
    }
    return false;
  }

  windowOpen(url, name, specs) {
    if (!url.match(/^https?:\/\//i)) {
      url = 'http://' + url;
    }
    return window.open(url);
  }

  edit(callback) {
    let prop = {
      properties: [],
      addresses: [],
      accountManagerId: this.props.company?.accountManagerId || null,
    };

    COMPANY_DETAILS_COMPANY_OWNER_CARD.map(type => {
      if (this.state[type] && type == 'phone_number') {
        prop.properties.push({
          name: type,
          value: this.state[type],
        });
        prop.properties.push({
          name: 'country_code',
          value: this.state?.country_code || '',
        });
      }
      if (this.state[type] && type != 'addresses') {
        prop.properties.push({
          name: type,
          value: this.state[type],
        });
      }
    });

    this.props.patch(prop.properties, this.props.company?.addresses, prop.accountManagerId, result => {
      this.reset();
    });
  }

  resetProps() {
    COMPANY_DETAILS_COMPANY_OWNER_CARD.map(property => {
      if (this.props.company[property]) {
        this.setState({ [property]: this.props.company[property], isEditCompany: false });
      }
    });
    if (this.props.company?.country_code) {
      this.setState({ country_code: this.props.company?.country_code });
    }
  }

  rows(company) {
    return COMPANY_DETAILS_COMPANY_OWNER_CARD;
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    const company = this.props.company;
    const address = company.addresses?.find(a => a.type?.name === 'home');
    const accountManager = company.accountManager;
    return (
      <Card className="company-info-card info-card data">
        <Container className="card-header">
          <HBox>
            <h2 className="card-title">{this.lbl('company.info.data.owner_info')}</h2>
            {this.state.isEditCompany && (
              <HBox className="button-block" right>
                <Button small select onClick={this.resetProps.bind(this)}>
                  {this.lbl('cancel')}
                </Button>
                &nbsp; &nbsp;
                <Button small onClick={this.edit.bind(this)}>
                  {this.lbl('save')}
                </Button>
              </HBox>
            )}
            {!this.state.isEditCompany && (
              <div
                className="icon-block"
                onClick={() => {
                  this.setState({ isEditCompany: true });
                }}
              >
                <EditSquare />
              </div>
            )}
          </HBox>

          <List>
            {this.rows().map(property => {
           
                      

              if (property == 'owner_name') {
                return (
                  
                  this.isShowPropertyCell(property) && (
                    <Row key={property}>
                      <Cell>{this.lbl(`company.property.${property}`)}</Cell>
                      {this.state.isEditCompany ? this.input(property) : <Cell>{company[property]}</Cell>}
                    </Row>
                  )
                );
              }

              if (property == 'date_of_foundation') {
                return (
                 
                  this.isShowPropertyCell(property) && (
                    <Row key={property}>
                      <Cell>{this.lbl(`company.property.${property}`)}</Cell>
                      {this.state.isEditCompany ? this.input(property) : <Cell>{company[property]}</Cell>}
                    </Row>
                  )
                );
              }
              if (property == 'type_ID') {
                return (
                 
                  this.isShowPropertyCell(property) && (
                    <Row key={property}>
                      <Cell>{this.lbl(`company.property.${property}`)}</Cell>
                      {this.state.isEditCompany ? this.input(property) : <Cell>{company[property]}</Cell>}
                    </Row>
                  )
                );
              }
              if (property == 'ID_number') {
                return (
                 
                  this.isShowPropertyCell(property) && (
                    <Row key={property}>
                      <Cell>{this.lbl(`company.property.${property}`)}</Cell>
                      {this.state.isEditCompany ? this.input(property) : <Cell>{company[property]}</Cell>}
                    </Row>
                  )
                );
              }
              if (property == 'expiration_date') {
                return (
                 
                  this.isShowPropertyCell(property) && (
                    <Row key={property}>
                      <Cell>{this.lbl(`company.property.${property}`)}</Cell>
                      {this.state.isEditCompany ? this.input(property) : <Cell>{company[property]}</Cell>}
                    </Row>
                  )
                );
              }
       
               
  

            
            
              return (
                this.isShowPropertyCell(property) && (
                  <Row key={property}>
                    <Cell className="cell-title">{this.lbl(`company.property.${property}`)}</Cell>
                    {this.state.isEditCompany ? (
                      this.input(property)
                    ) : (
                      <Cell className="info-cell">{this.lbl(`company.property.${property}.${company[property]}`)}</Cell>
                    )}
                  </Row>
                )
              );
            })}
          </List>
        </Container>
      </Card>
    );
  }
}

CompanyOwnerCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    patch(props, addresses, accountManagerId, callback) {
      dispatch(updateCompanyProperties(ownProps.company?.id, props, addresses, accountManagerId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyOwnerCard = compose(withConnect, withRouter)(CompanyOwnerCardComp);
